import { renderSlot as _renderSlot, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2e4899f8")

_pushScopeId("data-v-2e4899f8")
const _hoisted_1 = { class: "popup__body" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: {'bubbledown': _ctx.isBubbleDown, 'dropdown': _ctx.isDropDown},
    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "body", {}, undefined, true)
    ])
  ], 2))
})